import { useFormContext } from "react-hook-form";

import {
  PAYER_NAME_TOKEN,
  ORDER_NUMBER_TOKEN,
} from "shared/functions/ibanQrHelpers";

export const TOKEN_FIELD_MAP: Record<string, string> = {
  [`;${PAYER_NAME_TOKEN}`]: "requestPayerFullName",
  [`;${ORDER_NUMBER_TOKEN}`]: "requestOrderNumber",
  [PAYER_NAME_TOKEN]: "requestPayerFullName",
  [ORDER_NUMBER_TOKEN]: "requestOrderNumber",
};

const usePaymentPurposeKeyDown = () => {
  const { getValues, setValue } = useFormContext();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const el = e.currentTarget;
    const value = getValues("paymentPurpose") as string;
    const start = el.selectionStart ?? 0;
    const end = el.selectionEnd ?? 0;

    if ((e.key === "Backspace" || e.key === "Delete") && start !== end) {
      const selected = value.slice(start, end);
      Object.entries(TOKEN_FIELD_MAP).forEach(([token, field]) => {
        if (selected.includes(token)) setValue(field, false);
      });
      return;
    }

    if (e.key === "Backspace") {
      const token = Object.keys(TOKEN_FIELD_MAP).find((t) =>
        value.slice(0, start).endsWith(t),
      );
      if (token) {
        e.preventDefault();
        setValue(
          "paymentPurpose",
          value.slice(0, start - token.length) + value.slice(start),
        );
        setValue(TOKEN_FIELD_MAP[token], false);
      }
    }

    if (e.key === "Delete") {
      const token = Object.keys(TOKEN_FIELD_MAP).find((t) =>
        value.slice(start).startsWith(t),
      );
      if (token) {
        e.preventDefault();
        setValue(
          "paymentPurpose",
          value.slice(0, start) + value.slice(start + token.length),
        );
        setValue(TOKEN_FIELD_MAP[token], false);
      }
    }
  };

  return handleKeyDown;
};

export default usePaymentPurposeKeyDown;
